import columns from "../../../../../react-table/helpers/columns";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import { showTotalProp } from "../../../../../react-table/helpers/rowTotals";
import CarditCriticalElementsLocationReportMode from "./CarditCriticalElementsLocationReportMode";

export const getLocationTabNavigationProps =
  (originExchangeOfficesData) => (rowInfo, index) =>
    rowInfo && rowInfo.row
      ? {
          reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.id,
          mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
          requestParams: {
            carrierCode: rowInfo.row["carrier"], // eslint-disable-line
            originAirport:
              index === 0 ? "" : rowInfo.row["originAirport"][index], // eslint-disable-line
            originExchangeOffices:
              originExchangeOfficesData.originExchangeOffices,
            isSubtotal: index === 0,
          },
          selectionCriteriaOptions: {
            includeSelectionCriteria: true,
          },
        }
      : {};

const splitData = (data) => {
  return data.reduce(
    (acc, row) => {
      if (row.carrier && row.carrier.toLowerCase() === "total") {
        acc.totalRow = row;
      } else {
        acc.dataRows.push(row);
      }
      return acc;
    },
    {
      totalRow: undefined,
      dataRows: [],
    }
  );
};

export default (
  data,
  originExchangeOfficesData,
  mode = CarditCriticalElementsLocationReportMode.percentage
) => {
  const { totalRow } = splitData(data);

  const {
    NonZeroNumberColumn,
    MultilineColumn,
    MultilineNumberGroupedColumn,
    MultilinePercentageGroupedColumn,
    MultilineNumberNavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: "",
      columns: [
        new MultilineColumn("Carrier", "carrier").withTotalHeader(
          "Total",
          "bg-total-grey"
        ),
        new MultilineColumn("Origin airport", "originAirport").withTotalHeader(
          "",
          "bg-total-grey"
        ),
      ],
    },
    {
      Header: "Consignments",
      columns: [
        new MultilineNumberGroupedColumn(
          "Total",
          "consignments.total"
        ).withTotalHeader(
          showTotalProp(totalRow, "consignments.total"),
          "bg-total-grey"
        ),

        new MultilineNumberGroupedColumn(
          "LHOT origin",
          "consignments.lhotOrigin",
          true,
          "consignments.pctLhotOrigin"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.lhotOrigin"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),
        new MultilineNumberGroupedColumn(
          "LHOT destination",
          "consignments.lhotDestination",
          true,
          "consignments.pctLhotDestination"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.lhotDestination"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),
        new MultilineNumberGroupedColumn(
          "Contract reference",
          "consignments.contractReference",
          true,
          "consignments.pctContractReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.contractReference"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),
        new MultilineNumberGroupedColumn(
          "Booking reference",
          "consignments.bookingReference",
          true,
          "consignments.pctBookingReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.bookingReference"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),

        new MultilinePercentageGroupedColumn(
          "% LHOT origin",
          "consignments.pctLhotOrigin",
          true,
          "consignments.lhotOrigin"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.pctLhotOrigin", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
        new MultilinePercentageGroupedColumn(
          "% LHOT destination",
          "consignments.pctLhotDestination",
          true,
          "consignments.lhotDestination"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.pctLhotDestination", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
        new MultilinePercentageGroupedColumn(
          "% Contract reference",
          "consignments.pctContractReference",
          true,
          "consignments.contractReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.pctContractReference", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
        new MultilinePercentageGroupedColumn(
          "% Booking reference",
          "consignments.pctBookingReference",
          true,
          "consignments.bookingReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "consignments.pctBookingReference", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
      ],
    },
    {
      Header: "Receptacles",
      columns: [
        new MultilineNumberNavigationWithFooterColumn(
          new NonZeroNumberColumn("Total", "receptacles.total").withTotalHeader(
            showTotalProp(totalRow, "receptacles.total"),
            "bg-total-grey"
          ),
          getLocationTabNavigationProps(originExchangeOfficesData)
        ),

        new MultilineNumberGroupedColumn(
          "LHOT origin",
          "receptacles.lhotOrigin",
          true,
          "receptacles.pctLhotOrigin"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.lhotOrigin"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),
        new MultilineNumberGroupedColumn(
          "LHOT destination",
          "receptacles.lhotDestination",
          true,
          "receptacles.pctLhotDestination"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.lhotDestination"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),
        new MultilineNumberGroupedColumn(
          "Contract reference",
          "receptacles.contractReference",
          true,
          "receptacles.pctContractReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.contractReference"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),
        new MultilineNumberGroupedColumn(
          "Booking reference",
          "receptacles.bookingReference",
          true,
          "receptacles.pctBookingReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.bookingReference"),
            "bg-total-grey"
          )
          .withShow(mode === CarditCriticalElementsLocationReportMode.number),

        new MultilinePercentageGroupedColumn(
          "% LHOT origin",
          "receptacles.pctLhotOrigin",
          true,
          "receptacles.lhotOrigin"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.pctLhotOrigin", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
        new MultilinePercentageGroupedColumn(
          "% LHOT destination",
          "receptacles.pctLhotDestination",
          true,
          "receptacles.lhotDestination"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.pctLhotDestination", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
        new MultilinePercentageGroupedColumn(
          "% Contract reference",
          "receptacles.pctContractReference",
          true,
          "receptacles.contractReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.pctContractReference", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
        new MultilinePercentageGroupedColumn(
          "% Booking reference",
          "receptacles.pctBookingReference",
          true,
          "receptacles.bookingReference"
        )
          .withTotalHeader(
            showTotalProp(totalRow, "receptacles.pctBookingReference", true),
            "bg-total-grey"
          )
          .withShow(
            mode === CarditCriticalElementsLocationReportMode.percentage
          ),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_DETAILS.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_LOCATION.id,
        requestParams: {
          isTotal: originExchangeOfficesData.carrierCode === "*", // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          isSubtotal: originExchangeOfficesData.carrierCode !== "*", // since report expected to have one only group - * is handled on cape-be by reverting it back to ''
          carrierCode: originExchangeOfficesData.carrierCode,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
